import { Card, CardBody, CardHeader, Button } from "reactstrap";
import encryptStorage from "../../utils/Encryptstorage";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";

const RowItem = ({ label, value }) => (
  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
    <strong>{label}</strong>
    <span>{value}</span>
  </div>
);

const BurjTicketSuccess = () => {
  const history = useHistory();
  const [data, setData] = useState(null);

  useEffect(() => {
    const raw = encryptStorage.getItem("burjConfirmResult");
    if (raw) {
      try { setData(JSON.parse(raw)); } catch { setData(null); }
    }
  }, []);

  const dto = data?.getConfirmTicketDto?.ResponseData;

  return (
    <div className="container">
      <Card className="mt-4">
        <CardHeader>Booking Confirmed</CardHeader>
        <CardBody>
          {dto ? (
            <>
              <RowItem label="User Name" value={dto.UserName} />
              <RowItem label="Booking Amount" value={`AED ${dto.BookingAmount}`} />
              <RowItem label="Booking Date/Time" value={dto.BookingDateTime} />
              <RowItem label="Booking Id" value={dto.BookingId} />
              <RowItem label="Order Id" value={dto.OrderId} />
              <RowItem label="QR Code No" value={dto.QRCodeNo} />
              <RowItem label="Agent Name" value={dto.AgentName} />
              <RowItem label="Guest Name" value={dto.GuestName} />
              <RowItem label="Voucher No" value={dto.VoucherNo} />
              <RowItem label="Visit Date/Time" value={dto.VisitDateTime} />
              <div className="d-flex justify-content-end" style={{ gap: 12, marginTop: 16 }}>
                <Button color="primary" onClick={() => history.push("/")}>Go Home</Button>
              </div>
            </>
          ) : (
            <div>Nothing to show.</div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default BurjTicketSuccess;



